var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubeGrandeCentradaAzulBirdybacker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 145,
    viewBox: "0 0 631 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M597.777 0H25.8186C11.5518 0 0 11.5565 0 25.8293C0 40.1022 11.5518 51.6587 25.8186 51.6587H340.331C350.748 51.6587 359.189 60.1039 359.189 70.5245C359.189 80.9452 350.748 89.3903 340.331 89.3903H102.238C86.8848 89.3903 74.4445 101.836 74.4445 117.195C74.4445 132.554 86.8848 145 102.238 145H541.252C555.766 145 567.564 133.246 567.564 118.677C567.564 104.157 555.815 92.3535 541.252 92.3535H474.292C467.16 92.3535 461.377 86.5714 461.377 79.4389C461.377 72.3063 467.16 66.5242 474.292 66.5242H597.777C616.141 66.5242 631 51.6587 631 33.2867C631 14.9148 616.141 0.0493598 597.777 0.0493598V0Z",
    fill: "#B5EAD7",
    fillOpacity: 0.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubeGrandeCentradaAzulBirdybacker);
export default __webpack_public_path__ + "static/media/nube-grande-centrada-azul-birdybacker.e449a56f7b8d168154d5fe4b77d84ceb.svg";
export { ForwardRef as ReactComponent };